(function ($, Drupal, once) {
  Drupal.behaviors.component_key_facts = {
    attach: function (context) {

      // Key facts component
      const $keyFacts = $(context).find('.key-facts-container');

      // Horizontal scroll indicator init.
      $(once('key-facts-processed', $keyFacts, context)).each(function () {
        const $component = $(this);
        const $wrapper = $component.find('.field--name-field-key-facts.field__items');
        const $item = $wrapper.find('.field__item');

        $wrapper.horizontalScrollIndicator({ shadows: true });

        // Set popup
        $item.wrap('<div class="component-wrapper">');
        $item.prepend('<div class="close-btn"></div>');

        $item.click('on', function () {
          if ($(window).width() < 768 && !$(this).closest('.component-wrapper').hasClass('show')) {
            $(this).closest('.component-wrapper').addClass('show');
          }
        });
        $(document).on('click', '.close-btn', function () {
          $(this).closest('.field__item').closest('.component-wrapper').removeClass('show');
        });
      });
    }
  };
})(jQuery, Drupal, once);
